import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import SellDeliveryNoteStatusBar, { SellDeliveryNoteStatusBarNew, SellDeliveryNoteStatusBarProps } from '../../../SellDeliveryNStatusBar'
import SellDeliveryNoteFinishedStepButtons, { SellDeliveryNoteFinishedStepButtonsNew } from '../SellDeliveryNFinishedStepButtons'

type SellDeliveryNoteFinishedStepHeaderProps = & SellDeliveryNoteStatusBarProps & OrderStepButtonsBaseComponentProps

const SellDeliveryNoteFinishedStepHeaderDecider: React.FC<SellDeliveryNoteFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={SellDeliveryNoteFinishedStepHeaderDefault} NewComponent={SellDeliveryNoteFinishedStepHeaderNew} {...rest} />
    )
}

const SellDeliveryNoteFinishedStepHeaderDefault: React.FC<SellDeliveryNoteFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <SellDeliveryNoteStatusBar {...rest} />
            <SellDeliveryNoteFinishedStepButtons {...rest} />
        </div>
    )
}

const SellDeliveryNoteFinishedStepHeaderNew: React.FC<SellDeliveryNoteFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <SellDeliveryNoteStatusBarNew {...rest} />
            <SellDeliveryNoteFinishedStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default SellDeliveryNoteFinishedStepHeaderDecider